const pick = (lines) => lines[Math.floor(Math.random() * lines.length)];

const WRONG_ANSWER_LINES = [
  'Wrong country. The map just sighed.',
  'That’s not even the right continent.',
  'You clicked a rumor.',
  'Compass says no.',
  'Lost already?',
  'The globe hung up on you.',
  'You’d discover the snack aisle.',
  'That country is filing a restraining order.',
];

const RANKS = [
  {
    max: 0,
    animal: 'Snail',
    messages: [
      "Snail rank! 🐌 Zero. You pointed at the ocean and hoped it was a country. Magellan would hand you a coloring book.",
      "Snail rank! 🐌 You didn’t leave the harbor. GPS would file a missing-person report for your sense of direction.",
      "Snail rank! 🐌 If you were Columbus you’d sink in the parking lot and still miss India.",
    ],
  },
  {
    max: 3,
    animal: 'Turtle',
    messages: [
      "Turtle mode! 🐢 One lucky tap, then you treated Australia like a large swimming pool.",
      "Turtle mode! 🐢 You think the equator is a suggestion. That streak died on a country you could see from space.",
      "Turtle mode! 🐢 You’d follow a paper map into a wall. Slow, lost, and proud of it.",
    ],
  },
  {
    max: 7,
    animal: 'Rabbit',
    messages: [
      "Rabbit rank! 🐇 Mid geography at best. Don’t get hoppy — continents are not a group project.",
      "Rabbit rank! 🐇 A few correct clicks, then you treated Europe like a suburb and hoped nobody would notice.",
      "Rabbit rank! 🐇 Average with extra steps. You’d land in Portugal and ask where the kangaroos are.",
    ],
  },
  {
    max: 12,
    animal: 'Wolf',
    messages: [
      "Wolf rank? 🐺 Barely. A little above average isn’t a personality. The cartographers would scroll past this.",
      "Wolf rank? 🐺 The pack would leave you at the visitor center. You still think France is wherever the croissant vibes are.",
      "Wolf rank? 🐺 Not a disaster, which is the nicest thing anyone will say until you stop clicking the wrong landmass.",
    ],
  },
  {
    max: 19,
    animal: 'Cheetah',
    messages: [
      "Cheetah? 🐆 Don’t. A decent streak isn’t a geography degree. You almost had a real run, then got lost.",
      "Cheetah? 🐆 Close-ish. You’d still sink the Santa María three docks from home. Come back at 20.",
      "Cheetah? 🐆 Don’t frame this. Explorers with this score get a participation globe.",
    ],
  },
  {
    max: 24,
    animal: 'Falcon',
    messages: [
      "Falcon-level geography! 🦅 That’s actually impressive. You found countries like you own an atlas — then still walked off the map.",
      "Falcon-level memory of the globe! 🦅 Rare praise: you earned it. Shame the last click thought Greenland was a grocery store.",
    ],
  },
  {
    max: Infinity,
    animal: 'Peregrine Falcon',
    messages: [
      "Peregrine Falcon! 🦅 Are you even human? Columbus wishes his “India” had this many correct taps. Then you still found a way to miss.",
      "Peregrine Falcon! 🦅 Atlas menace. That streak was real — the last miss is the only proof you’re mortal.",
    ],
  },
];

export const pickWrongCountryRoast = () => pick(WRONG_ANSWER_LINES);

export const getCountryMapRank = (score) => {
  const n = Number(score);
  const value = Number.isFinite(n) && n > 0 ? n : 0;
  const rank = RANKS.find((entry) => value <= entry.max) || RANKS[RANKS.length - 1];
  return {
    animal: rank.animal,
    message: pick(rank.messages),
  };
};
